/**
 * 粘性效果组件
 * 模拟 position: sticky 行为，提供跨浏览器的粘性定位功能
 * 
 * @module common/components/StickyEffect
 * @author wei<innereyecw@gmail.com>
 * @version 5.0.0
 */
(function (global) {
  "use strict";

  // 确保命名空间存在
  if (!global.watashi) {
    global.watashi = {};
  }
  if (!global.watashi.common) {
    global.watashi.common = {};
  }

  const common = global.watashi.common;
  const logger = (global.watashi.core && global.watashi.core.logger) || console;

  /**
   * 粘性效果组件
   * @class StickyEffect
   * 
   * @example
   * new watashi.common.StickyEffect({
   *   container: '#stickyElement',
   *   offset: 0,
   *   type: 'default'
   * });
   */
  common.StickyEffect = (function () {
    const defaults = {
      container: '',
      offset: 0,
      type: 'default',
      stickyClasses: {
        top: 'takeoff-top',
        bottom: 'takeoff',
        default: 'takeoff',
      },
      typeCompatible: {
        stickyTop: 'top',
        sticky: 'bottom',
        default: 'default',
      },
    };

    /**
     * 创建粘性效果实例
     * @param {Object} options - 配置选项
     */
    function StickyEffect(options) {
      this.settings = {...defaults, ...options};
      this.container = document.querySelector(this.settings.container);
      this.init();
    }

    const _stickyEffect = StickyEffect.prototype;

    /**
     * 初始化粘性效果
     */
    _stickyEffect.init = function () {
      if (this.container) {
        this.run();
        this.bindEvents();
      } else {
        logger.log(`StickyEffect init failed: ${this.settings.container}`, 'warn');
      }
    };

    /**
     * 绑定滚动事件
     */
    _stickyEffect.bindEvents = function () {
      common.registerEvent(window, 'scroll', this.run.bind(this));
    };

    /**
     * 执行粘性效果检测
     */
    _stickyEffect.run = function () {
      const typeKey = this.container.dataset.type;
      const compatibleType = this.settings.typeCompatible && this.settings.typeCompatible[typeKey];
      const type = compatibleType || this.settings.type;
      const className = this.settings.stickyClasses[type] || this.settings.stickyClasses.default;
      const isSticky = this.isSticky(type);

      if (isSticky) {
        this.container.classList.add(className);
      } else {
        this.container.classList.remove(className);
      }
    };

    /**
     * 判断是否应该应用粘性效果
     * @param {string} type - 类型：'top' | 'bottom' | 'default'
     * @returns {boolean}
     */
    _stickyEffect.isSticky = function (type) {
      const offset = type === 'top' ? this.settings.offset : type === 'bottom' ? this.settings.offset : 0;
      const containerRect = this.container.getBoundingClientRect();

      if (type === 'top') {
        return containerRect.top < offset;
      } else if (type === 'bottom' || type === 'default') {
        return containerRect.bottom > document.documentElement.clientHeight - offset;
      }
      return false;
    };

    return StickyEffect;
  })();

})(typeof window !== "undefined" ? window : this);
